import { render, staticRenderFns } from "./CatalogMenuTree.vue?vue&type=template&id=10173819&scoped=true"
import script from "./CatalogMenuTree.vue?vue&type=script&lang=js"
export * from "./CatalogMenuTree.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenuTree.vue?vue&type=style&index=0&id=10173819&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10173819",
  null
  
)

export default component.exports